import { CommonModule } from '@angular/common';
import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { ModalRef, ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-component-modal-host',
  imports: [CommonModule],
  templateUrl: './modal-host.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './modal-host.component.css',
})
export class ModalHostComponent {
  private modalService = inject(ModalService);

  activeModals = this.modalService.activeModals;
  activeModal = this.modalService.activeModal;

  constructor() {
    effect(() => {
      const hasModalOpen = this.modalService.isOpen();
      document.body.classList.toggle('overflow-hidden', hasModalOpen);
    });
  }

  onBackdropClick(modalRef: ModalRef): void {
    const modal = this.activeModal();
    if (
      !modal ||
      modal.ref !== modalRef ||
      modal.options.backdrop === 'static'
    ) {
      return;
    }

    this.modalService.dismissActive('backdrop-click');
  }

  onEscapeKey(event: Event, modalRef: ModalRef): void {
    const modal = this.activeModal();
    if (!modal || modal.ref !== modalRef || !modal.options.keyboard) {
      return;
    }

    (event as KeyboardEvent).preventDefault();
    this.modalService.dismissActive('esc');
  }

  isTopModal(modalRef: ModalRef): boolean {
    return this.activeModal()?.ref === modalRef;
  }

  getModalSizeClass(modalRef: ModalRef): string {
    const size =
      this.activeModals().find((modal) => modal.ref === modalRef)?.options
        .size ?? 'lg';

    switch (size) {
      case 'sm':
        return 'max-w-md';
      case 'md':
        return 'max-w-xl';
      case 'xl':
        return 'max-w-5xl';
      case 'lg':
      default:
        return 'max-w-3xl';
    }
  }
}
